function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Table, Spinner, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import Common from "../../components/includes/Common";
import { Skeleton, Button, Form, Input, DatePicker, Modal, Drawer, message, Tag } from 'antd';
import { EyeFill, TrashFill, PenFill, EyeSlashFill, Search, EmojiSmileFill, BriefcaseFill, CheckCircleFill, EmojiSmileUpsideDown, PersonLock } from 'react-bootstrap-icons';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ManageUsers = function ManageUsers() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    users = _useState2[0],
    setUsers = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingData = _useState4[0],
    setLoadingData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingMoreData = _useState6[0],
    setLoadingMoreData = _useState6[1];
  var _useState7 = useState(3),
    _useState8 = _slicedToArray(_useState7, 2),
    limit = _useState8[0],
    setLimit = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    offset = _useState10[0],
    setOffset = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedUser = _useState12[0],
    setSelectedUser = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    actionDone = _useState16[0],
    setActionDone = _useState16[1];
  var loadUsers = function loadUsers() {
    setLoadingData(true);
    var request = axios.get(Common.baseApiUrl + 'getusers/' + limit.toString() + '/' + offset.toString() + '/0');
    request.then(function (response) {
      setLoadingData(false);
      if (response.data.status == 200) {
        setUsers(response.data.users);
        setOffset(offset + limit);
      }
    })["catch"](function (error) {
      setLoadingData(false);
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  };
  var onChange = function onChange(e) {
    setLoadingData(true);
    if (e.target.value == '' || e.target.value == ' ') {
      loadUsers();
      return;
    }
    axios.get(Common.baseApiUrl + 'getusersfrommobile/' + e.target.value).then(function (response) {
      if (response.data.status == 200) {
        setUsers(response.data.users);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  };
  var loadMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setOffset(offset + limit);
            setLoadingMoreData(true);
            _context.next = 4;
            return axios.get(Common.baseApiUrl + 'getusers/' + limit.toString() + '/' + offset.toString() + '/0').then(function (response) {
              setLoadingMoreData(false);
              if (response.data.status == 200) {
                setUsers(users.concat(response.data.users));
              }
            })["catch"](function (error) {
              setLoadingMoreData(false);
              message.error({
                content: 'Une erreur est survenue',
                delay: 4
              });
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadMore() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUserActivation = function handleUserActivation(user) {
    setSelectedUser(user);
    var action = user.status == 0 ? 'Activation' : 'Désactivation';
    Modal.confirm({
      title: 'Confirmation',
      content: action + ' de ' + user.mobile.slice(3) + ' ?',
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'switchuserstatus', {
          uid: user.id,
          aid: Common.currentcurrentUser.id,
          status: user.status
        }).then(function (response) {
          if (response.data.status == 200) {
            var nr = users.map(function (u) {
              if (u.id == user.id) {
                return _objectSpread(_objectSpread({}, u), {}, {
                  status: u.status == 0 ? 1 : 0
                });
              }
              return u;
            });
            setUsers(nr);
            message.success({
              content: response.data.message,
              duration: 5,
              key: 1,
              icon: /*#__PURE__*/_jsx(EmojiSmileFill, {
                size: 25
              })
            });
          } else {
            message.error({
              content: response.data.message,
              duration: 5,
              key: 0
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            duration: 5,
            key: 0
          });
        });
      }
    });
  };
  useEffect(function () {
    setDataChanged(false);
    loadUsers();
  }, [dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "data-container",
            children: [/*#__PURE__*/_jsx("div", {
              className: "admin-filter-box cool-radius white-bg",
              children: /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 5,
                  sm: 8,
                  children: /*#__PURE__*/_jsx(Input, {
                    suffix: /*#__PURE__*/_jsx(Search, {
                      size: 22
                    }),
                    onChange: onChange,
                    placeholder: "Numero mobile"
                  })
                })
              })
            }), /*#__PURE__*/_jsx("br", {}), users.length ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs(Table, {
                striped: true,
                bordered: true,
                hover: true,
                responsive: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: "#"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Nom"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Type de compte"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Pays"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Email"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Telephone"
                    }), /*#__PURE__*/_jsx("th", {})]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: users.map(function (u) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: u.id
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.firstname + ' ' + u.lastname
                      }), /*#__PURE__*/_jsxs("td", {
                        children: [u.role == 1 && /*#__PURE__*/_jsxs(Tag, {
                          icon: /*#__PURE__*/_jsx(EmojiSmileUpsideDown, {}),
                          color: "#6C34D0",
                          children: [" ", /*#__PURE__*/_jsx("b", {
                            children: " Utilisateur"
                          })]
                        }), u.role == 2 && /*#__PURE__*/_jsxs(Tag, {
                          icon: /*#__PURE__*/_jsx(BriefcaseFill, {}),
                          color: "#D05534",
                          children: [" ", /*#__PURE__*/_jsx("b", {
                            children: " Promoteur"
                          })]
                        }), u.role == 3 && /*#__PURE__*/_jsxs(Tag, {
                          icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                          color: "#368644",
                          children: [" ", /*#__PURE__*/_jsx("b", {
                            children: " Promoteur certifi\xE9"
                          })]
                        }), u.role > 700 && /*#__PURE__*/_jsxs(Tag, {
                          icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                          color: "#368644",
                          children: [" ", /*#__PURE__*/_jsx("b", {
                            children: " Admin"
                          })]
                        })]
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.country.label
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.email
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.mobile.slice(3)
                      }), /*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          icon: u.status == 1 ? /*#__PURE__*/_jsx(EyeFill, {
                            size: 21
                          }) : /*#__PURE__*/_jsx(EyeSlashFill, {
                            size: 21
                          }),
                          onClick: function onClick() {
                            handleUserActivation(u);
                          }
                        })
                      })]
                    }, u.id);
                  })
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "load-more-box",
                children: [/*#__PURE__*/_jsx("br", {}), loadingMoreData && /*#__PURE__*/_jsx(Spinner, {
                  animation: "grow",
                  variant: "info"
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
                  className: "borderless",
                  type: "default",
                  onClick: loadMore,
                  children: "Voir plus"
                })]
              })]
            }) : /*#__PURE__*/_jsx(_Fragment, {
              children: loadingData ? /*#__PURE__*/_jsx(Skeleton, {
                active: true
              }) : /*#__PURE__*/_jsx("div", {
                children: "Aucune donn\xE9e"
              })
            })]
          })
        })
      })
    })
  });
};
export default ManageUsers;